module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'fmz0q3xc',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
